const mutations = {
  setProfile(state, profile) {
  state.profile = Object.assign(state.profile, profile);
  }
};

export default mutations;
